import styles from "./CVEVulnerableSoftwareList.module.css";
import react, { useEffect, useState } from "react";

export const PublishedDateFilter = ({ valueRef }) => {
    const [value, setValue] = useState(valueRef.current);
    const min=0;
    const max=365;

    const handleChange = (input) => {
        
        // Allow only digits or empty string
        if (!/^\d*$/.test(input)) {
            return;
        }

        if (input === "") 
        {
            setValue("0");
            valueRef.current = "0";
            return;
        }

        const num = Number(input);

        if (num >= min && num <= max) 
        {
            setValue(num.toString());
            valueRef.current = String(num.toString());
        }
    };

    return (
        <div className={styles.grid} style={{ padding:"0.6rem 0.8rem",background:"white" }}>
            <div 
                className={styles.flex} 
                onClick={()=>{
                    if(value==="")
                        handleChange("1")
                    else
                    {
                        setValue("");
                        valueRef.current = "";
                    }
                }}
            >
                <input
                    type="radio"
                    checked={value!==""}
                    id={"custom"}
                />
                <label>Custom Days</label>
            </div>
            {value!=="" &&
                <div className={styles.flex} style={{paddingLeft:"24px"}}>
                    <div>Last</div>
                    <input
                        className={styles.input}
                        value={value}
                        onChange={(e) => handleChange(e.target.value)}
                    />
                    <div>day(s)</div>
                </div>
            }
        </div>
    );
};

export const RiskScoreFilter = ({ valueRef }) => {
    const MIN = 0;
    const MAX = 10;

    const [fromValue, setFromValue] = useState(
        valueRef.current?.split("-")[0] || String(MIN)
    );

    const [toValue, setToValue] = useState(
        valueRef.current?.split("-")[1] || String(MAX)
    );

    const updateValue = (from, to) => {
        if (from !== "" && to !== "")
            valueRef.current = `${from}-${to}`;
        else
            valueRef.current = "";
    };

    const handleFromBlur = () => {
        if (fromValue === "") 
        {
            setFromValue(String(MIN));
            updateValue(String(MIN), toValue);
        }
    };

    const handleToBlur = () => {
        if (toValue === "") 
        {
            setToValue(String(MAX));
            updateValue(fromValue, String(MAX));
        }
    };

    const handleFromChange = (e) => {
        const input = e.target.value;

        // Allow only digits or empty string
        if (!/^\d*$/.test(input)) {
            return;
        }

        if (input === "") {
            setFromValue("");
            updateValue("", toValue);
            return;
        }

        const num = Number(input);

        if (num < MIN || num > MAX) return;

        // // from should be <= to
        // if (toValue !== "" && num > Number(toValue)) return;

        setFromValue(num.toString());
        updateValue(num.toString(), toValue);
    };

    const handleToChange = (e) => {
        const input = e.target.value;

        if (input === "") 
        {
            setToValue("");
            updateValue(fromValue, "");
            return;
        }

        const num = Number(input);

        if (num < MIN || num > MAX) return;

        // // to should be >= from
        // if (fromValue !== "" && num < Number(fromValue)) return;

        setToValue(num.toString());
        updateValue(fromValue, num.toString());
    };

    return (
        <div className={styles.flex} style={{ padding:"0.6rem 0.8rem",background:"white" }}>
            <div className={styles.flex} style={{ marginBottom: "0.5rem" }}>
                <div>From</div>
                <input
                    type="number"
                    className={styles.input}
                    style={{width:"30%"}}
                    value={fromValue}
                    onBlur={handleFromBlur}
                    onChange={handleFromChange}
                />
            </div>

            <div className={styles.flex}>
                <div>To</div>
                <input
                    type="number"
                    className={styles.input}
                    style={{width:"30%"}}
                    value={toValue}
                    onBlur={handleToBlur}
                    onChange={handleToChange}
                />
            </div>
        </div>
    );
};